import React, { useState } from 'react';
import "./css/prebooking.css";

const PreBookingIncrementDecrement = ({ initialValue, onChange }) => {
  const [count, setCount] = useState(Math.max(0, initialValue)); // Ensure initial value is at least 0

  const handleDecrement = () => {
    if (count > 0) {
      setCount(count - 1);
      onChange(count - 1);
    }
  };

  const handleIncrement = () => {
    setCount(count + 1);
    onChange(count + 1);
  };

  return (
    <div className="pre-booking-increment-wrapper">
      <div className="pre-input_decrement" onClick={handleDecrement}>
        <p>-</p>
      </div>
      <div className="pre-input_field_txt">

      <input
        type="number"
        className='pre-input_field'
        placeholder=""
        value={count}
        onChange={(e) => {
          const newValue = parseInt(e.target.value);
          setCount(Math.max(0, newValue)); // Enforce minimum on input change
          onChange(Math.max(0, newValue));
        }}
        
      />
      </div>
      <div className="pre-input_decrement" onClick={handleIncrement}>
        <p>+</p>
      </div>
    </div>
  );
};

export default PreBookingIncrementDecrement;
